import {
    
    SET_STARASSIGNMENT_LIST,
    SET_STARASSIGNMENT_TYPE_CATEGORY,
    SET_STARTYPES_LIST,
    SET_CARDSLIST,
    SET_LIST_HISTORICAL_TEMPLATE,
    SET_DOWNLOAD_TEMPLATE,
    SET_POST_TEMPLATE
} from "@/views/star_assignment/store/types/types.js";

const mutations = {
    
    [SET_STARASSIGNMENT_LIST ]: (state, payload) => state.typeDocumentStarassignment = payload, 
    [SET_STARTYPES_LIST ]: (state, payload) => state.typeStar = payload,
    [SET_STARASSIGNMENT_TYPE_CATEGORY]: (state, payload) => state.typeCategoryStarAssignment = payload,
    [SET_CARDSLIST]: (state, payload) => state.cardsList = payload, 
    [SET_LIST_HISTORICAL_TEMPLATE]: (state, payload) => state.template = payload, 
    [SET_DOWNLOAD_TEMPLATE]: (state, payload) => state.templateDownload = payload, 
    [SET_POST_TEMPLATE]: (state, payload) => state.postTemplate = payload, 
};

export default mutations